import React, { useRef } from 'react'
import styles from './index.module.css'
import MailSvg from '@/components/Icons/MailSvg'
import CustomerServiceSvg from '@/components/Icons/CustomerServiceSvg'
import DownloadSvg from '@/components/Icons/DownloadSvg'
import { useTranslation } from '@sailor/i18n-web'
import { QRCodeCanvas } from 'qrcode.react'
import { Link } from 'react-router-dom'

import { DOWNLOAD_LINK } from '@/common/utils/consts'

const ContactBar: React.FC = () => {
  const { t } = useTranslation()
  const downloadRef = useRef(null)
  return (
    <div className={styles.contactBar}>
      <div className={styles.item}>
        <MailSvg className={styles.icon} />
        <span>{t('ent_o_footer_contact_corporate', 'Corporate Services')}</span>
        <div className={styles.popover}>
          <div className={styles.popoverContent}>
            <p className={styles.popoverText}>corporate.hk@keetainc.com</p>
          </div>
        </div>
      </div>
      <div className={styles.line}></div>
      <Link to="/contact" className={`${styles.item} ${styles.linkItem}`}>
        <CustomerServiceSvg className={styles.icon} />
        <span>{t('ent_o_nav_contact', '联系我们')}</span>
      </Link>
      <div className={styles.line}></div>
      <div className={styles.item}  ref={downloadRef}>
        <DownloadSvg className={styles.icon} />
        <span>{t('ent_o_nav_app_download', '应用下载')}</span>
        <div className={styles.popover}>
          <div className={styles.popoverContent}>
            <QRCodeCanvas value={DOWNLOAD_LINK}  style={{ width: '10rem', height: '10rem', padding: '5px', borderRadius: '10px' }}/>
            <p className={styles.popoverText}>APP</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ContactBar
